import React from 'react';
import { ListItemButton, ListItemText } from '@mui/material';
import StarsIcon from '@mui/icons-material/Stars';
import { useDispatch } from 'react-redux';
import { getResult, getVIMSSearchResult, clearResults, markFavouriteSearches } from '../../../../store/search/actions';

type DeviceList = { option: any, page?: string };

const RecentList = ({ option, page }: DeviceList) => {
  const dispatch = useDispatch();

  const clickHandler = () => {
    dispatch(clearResults());
    if (page === 'vims-transactions') {
      dispatch(getVIMSSearchResult(option?.value));
    } else {
      dispatch(getResult(option?.value));
    }
  };

  return (
    <ListItemButton onClick={() => clickHandler()}>
      <ListItemText primary={option?.value} />
      <StarsIcon htmlColor={option?.isFavourite ? "#FFC300" : "$000000"} onClick={() => dispatch(markFavouriteSearches(option))} />
    </ListItemButton>
  );
};

export default RecentList;
